// ----------------------------------------------------------------------------
// Snippet: Rebuy Templates
// ----------------------------------------------------------------------------


// -------------------------------------
// Dependencies
// -------------------------------------

// Styles
import './_rebuy-templates.scss';


document.addEventListener('rebuy:smartcart.ready', function() {
    const SmartCart = window.Rebuy?.SmartCart;

    // Initial check when SmartCart is ready
    handlePickupOnlyItems(SmartCart);

    // Re-run the check whenever the cart is updated
    document.addEventListener('rebuy:cart.add', function(event) {
        const recentItem = event.detail.item;
        const { product_id: recentProductID, variant_id: recentVariantID } = recentItem || {};

        // Check if the pickup item exists before appending
        const pdpRebuyCartPickup = document.querySelector(`.js__rebuy-cart-pickup_${recentProductID}_${recentVariantID}`);
        
        if (pdpRebuyCartPickup) {
            // Delay appending to ensure that SmartCart is fully rendered
            setTimeout(() => onAddToCartPickupOnlyItem(SmartCart, recentProductID, recentVariantID), 300);
        }
    });
});

function handlePickupOnlyItems(SmartCart) {
    if (!SmartCart?.cartElement) return;

    SmartCart.cartElement.querySelectorAll('.js__pickup-only-wrapper').forEach(wrapper => {
        const productId = wrapper.getAttribute('data-product-id');
        const variantId = wrapper.getAttribute('data-variant-id');

        const pickupOnlyItem = wrapper.querySelector(`.js__pickup-only-item[data-product-id="${productId}"][data-variant-id="${variantId}"]`);
        
        if (pickupOnlyItem) {
            pickupOnlyItem.style.display = 'block';
        }
    });
}

// Function to handle appending the pickup-only item
function onAddToCartPickupOnlyItem(SmartCart, recentProductID, recentVariantID) {
    if (!SmartCart?.cartElement) return;

    const pickupOnlyWrapper = SmartCart.cartElement.querySelector(`.js__pickup-add-to-cart[data-product-id="${recentProductID}"][data-variant-id="${recentVariantID}"]`);
    
    if (pickupOnlyWrapper) {
        pickupOnlyWrapper.style.display = 'block';
    }
}



